import React from "react";
import { ReactPopover } from "./ReactPopover";

type Props = {
  isActive: boolean;
  imagePath: string;
  popupTitle: string;
}
export const FeatureEnableFlag: React.FC<Props> = ({ isActive, imagePath, popupTitle }) => {
  return <>
    <ReactPopover className={"h-full w-[24px]"} trigger={"hover"} content={
      <div className={"flex justify-center text-sm text-muted"}>
        {popupTitle}
      </div>
    }>
      <img
        src={imagePath}
        style={{
          filter: isActive ? undefined : "grayscale(100%)",
          opacity: isActive ? 1 : 0.6
        }}
        className={"h-full"}
        alt={"clips"}
      />
    </ReactPopover>
  </>;
};
